<script>
import { throttle } from 'lodash'
import appbarMixin from '@/v-shop/appbarMixin'
import { sync } from 'vuex-pathify'

export default {
	mixins: [appbarMixin],
	props: {
		showMenu: Boolean,
	},
	hooksKey: 'AppBar',
	provide() {
		return {
			hookContainer: () => this,
		}
	},
	data() {
		return {
			lastScrollPosition: 0,
			slides: this.$srv('AppBarSlider', []),
			debouncedFn: null,
			scrollIsAtTop: true,
		}
	},
	mounted() {
		window.addEventListener('scroll', this.debouncedOnScrollY())
		if (!this.$ssr) {
			const { height } = this.$refs.nav.children.item(0).getBoundingClientRect()
			this.navbarHeight = height
		}
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.debouncedFn)
	},
	watch: {
		'$route.name'(routeName) {
			if (!this.$b.d && routeName !== 'home') {
				this.$refs.nav.classList.remove('position-fixed')
			} else {
				this.$refs.nav.classList.remove('position-sticky')
			}
		},
	},
	methods: {
		onScrollY(event) {
			this.scrollIsAtTop = window.scrollY === 0

			if (this.$b.d && !this.config.stickyNavbar) return

			const navClassList = this.$refs.nav.classList
			const currentYPosition = window.scrollY
			const isSticky = currentYPosition > 0
			const showSticky = isSticky && currentYPosition < this.lastScrollPosition

			this.lastScrollPosition = currentYPosition

			this.forceTransparency = isSticky
			navClassList.toggle('slide-appbar', isSticky)
			navClassList.toggle('slide-appbar-show', showSticky)

			if (this.isHomeRoute && this.appbarTransparent) {
				navClassList.toggle('position-fixed', isSticky)
			} else {
				navClassList.toggle('position-sticky', isSticky)
			}
		},
		debouncedOnScrollY() {
			this.debouncedFn = throttle(this.onScrollY, 200)
			return this.debouncedFn
		},
	},
	computed: {
		navbarHeight: sync('shop/navbarHeight'),
		type() {
			const type = this.$srv('AppBarConfig.type', 'regular')
			if (type === 'regular') return 'regular'
			// show round appbar on mobile only
			if (type === 'round' && this.$b.mt) return 'regular'
			return 'round'
		},
		forceTransparency: sync('shop/loading'),
		autoplayDelay() {
			return Number(this.$srv('AppBarSlider.autoplayDelay', 3))
		},
		imagesRatio() {
			return this.$b.xs ? 0.636 : 1.8604
		},
		styles() {
			if (this.makeAppbarTransparent && !this.$b.d && this.type === 'regular') {
				return {
					position: 'absolute',
					top: this.$b.d && '48px',
				}
			}
			if (this.type === 'round') {
				return {
					position: 'sticky',
					top: 0,
				}
			}
			return ''
		},
	},
	cssVars: {
		selector: '.appbar',
	},
	eventsListeners: {
		focusMobileSearch() {
			const navClassList = this.$refs.nav.classList

			navClassList.toggle('slide-appbar', 1)
			navClassList.toggle('slide-appbar-show', 1)
		},
	},
}
</script>

<template>
	<div
		ref="nav"
		class="appbar d-flex flex-column align-center w100"
		:class="$b.d && 'position-fixed'"
		style="z-index: 5"
		:style="styles"
	>
		<div class="w100" v-if="type === 'regular'">
			<v-expand-transition>
				<div v-show="scrollIsAtTop">
					<hook zone="top-msg">
						<AppBar-TopMsg />
					</hook>
				</div>
			</v-expand-transition>
			<AppBar-Top :style="makeAppbarTransparent && scrollIsAtTop && 'background: transparent!important'" />
			<div v-if="$b.td">
				<v-expand-transition>
					<div v-show="scrollIsAtTop">
						<hook zone="appbar-bottom">
							<AppBar-Bottom />
						</hook>
					</div>
				</v-expand-transition>
			</div>
		</div>
		<div class="d-flex justify-center w100 my-2" :class="$route.name === 'home' ? 'absolute' : ''" v-else>
			<AppBarRound class="base appbar-round w100" />
		</div>
	</div>
</template>

<style scoped lang="scss">
.absolute {
	position: absolute;
	top: 0;
}

.appbar-round {
	max-width: 1200px;
	border-radius: 80px;
}

::v-deep .ssr-carousel-slides {
	width: 100%;
}

.slider {
	position: relative;
}

.w100 {
	width: 100%;
}

.position-fixed {
	position: fixed;
}

.position-sticky {
	position: sticky;
}

.slide-appbar {
	z-index: 1;
	top: -144px; // solo en mobile
	transition: 0.3s top;

	&.slide-appbar-show {
		top: 0;
	}
}
</style>
